var exports = {
  "k": "xaf9ae18d--dc113c--container",
  "Q": "xaf9ae18d--dc113c--text",
};

module.exports = exports;
